@if (tour.active()) {
  <!-- Soft gradient rising from the bottom edge, blending the dock into the page.
       pointer-events: none — the page stays fully interactive. -->
  <div class="demo-tour-scrim" [class.leaving]="tour.leaving()"></div>

  <!-- Glow ring on the current page's nav item ("you are here"); one persistent
       element, so it glides between nav items as the tour advances. -->
  @if (navGlow(); as glow) {
    <div
      class="demo-tour-nav-glow"
      [class.leaving]="tour.leaving()"
      [style.top.px]="glow.top"
      [style.left.px]="glow.left"
      [style.width.px]="glow.width"
      [style.height.px]="glow.height">
    </div>
  }

  <div class="demo-tour-dock" [class.leaving]="tour.leaving()" role="complementary" aria-label="Demo tour">
    <div class="demo-tour-progress">
      <div class="demo-tour-progress-fill" [style.width.%]="progressPct()"></div>
    </div>
    <button class="demo-tour-close" (click)="skip()" aria-label="Dismiss tour">
      <span class="material-icons">close</span>
    </button>
    @if (displayStep(); as step) {
      <div class="demo-tour-content" [class.is-out]="phase() === 'out'" [class.is-in]="phase() === 'in'">
        <div class="demo-tour-main">
          <div class="demo-tour-icon">
            <span class="material-icons">{{ step.icon }}</span>
          </div>
          <div class="demo-tour-text">
            <div class="demo-tour-eyebrow">
              <span class="material-icons">auto_awesome</span>
              <span>Quick Tour · {{ displayIndex() + 1 }} of {{ tour.steps().length }}</span>
            </div>
            <div class="demo-tour-title">
              <tidy-text [header]="step.title" />
            </div>
            <div class="demo-tour-body">
              <tidy-text [body]="step.body" />
            </div>
          </div>
        </div>
        <div class="demo-tour-footer">
          <div class="demo-tour-chips">
            @for (chip of step.chips; track chip) {
              <span class="demo-tour-chip">
                <span class="material-icons">check</span>
                <span class="demo-tour-chip-label">{{ chip }}</span>
              </span>
            }
          </div>
          <div class="demo-tour-controls">
            <button class="demo-tour-skip" (click)="skip()">Skip tour</button>
            <button class="demo-tour-next" (click)="next()">
              {{ nextLabel() }}
              <span class="material-icons">chevron_right</span>
            </button>
          </div>
        </div>
      </div>
    }
  </div>
}
